export function QBOSupportFindProductByNameCtrl ($scope, domainParserApi, results) {

  $scope.results = results ? results : {};

  // IE specific properties to enable flipper modal compatibility
  $scope.IE = domainParserApi.isInternetExplorer();
  $scope.flipped = false;

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'key',
        header : {
          classes: 'text-left',
          text   : 'ID'
        },
      },
      {
        field : 'value',
        header: {
          classes: 'text-left',
          text   : 'Value'
        },
        classes: 'text-left'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ITEMS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: true
    },
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.flipped = !$scope.flipped;
    $scope.result = event.row;
    $('.modal-content').addClass('flip');
  };

  $scope.back = function () {
    $('.modal-content').removeClass('flip');
  };
}